module.exports = __webpack_public_path__ + "img/notice.338506fe.svg";